import { c as _c } from "react/compiler-runtime";
import { useMemo, useState, useEffect } from "react";
import { isValidEthAddress } from "@/helpers/Helpers";
import { useCollectionSearch, useContractOverviewQuery, primeContractCache } from "@/hooks/useAlchemyNftQueries";
import { useDebouncedValue } from "@/hooks/useDebouncedValue";
import type { Suggestion, SupportedChain } from "../types";
type UseNftSearchProps = {
  chain: SupportedChain;
  debounceMs: number;
  hideSpamProp: boolean;
};
export function useNftSearch(t0) {
  const $ = _c(36);
  const {
    chain,
    debounceMs,
    hideSpamProp
  } = t0;
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [hideSpam, setHideSpam] = useState(hideSpamProp);
  let t1;
  let t2;
  if ($[0] !== hideSpamProp) {
    t1 = () => {
      setHideSpam(hideSpamProp);
    };
    t2 = [hideSpamProp];
    $[0] = hideSpamProp;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== query) {
    t3 = isValidEthAddress(query.trim());
    $[3] = query;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isAddressQuery = t3;
  let t4;
  bb0: {
    if (!isAddressQuery) {
      t4 = undefined;
      break bb0;
    }
    let t5;
    if ($[5] !== query) {
      t5 = query.trim();
      $[5] = query;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = t5 as `0x${string}`;
  }
  const contractQueryAddress = t4;
  const t5 = !isAddressQuery && query.length > 1;
  let t6;
  if ($[7] !== chain || $[8] !== debounceMs || $[9] !== hideSpam || $[10] !== query || $[11] !== t5) {
    t6 = {
      query,
      chain,
      hideSpam,
      debounceMs,
      enabled: t5
    };
    $[7] = chain;
    $[8] = debounceMs;
    $[9] = hideSpam;
    $[10] = query;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const {
    data: searchResult,
    isFetching: isSearchFetching
  } = useCollectionSearch(t6);
  const t7 = Boolean(contractQueryAddress);
  let t8;
  if ($[13] !== chain || $[14] !== contractQueryAddress || $[15] !== t7) {
    t8 = {
      address: contractQueryAddress,
      chain,
      enabled: t7
    };
    $[13] = chain;
    $[14] = contractQueryAddress;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const addressOverviewQuery = useContractOverviewQuery(t8);
  searchResult?.items;
  let t9;
  bb1: {
    if (contractQueryAddress && addressOverviewQuery.data) {
      let t10;
      if ($[17] !== addressOverviewQuery.data) {
        t10 = [addressOverviewQuery.data];
        $[17] = addressOverviewQuery.data;
        $[18] = t10;
      } else {
        t10 = $[18];
      }
      t9 = t10;
      break bb1;
    }
    let t10;
    if ($[19] !== searchResult?.items) {
      t10 = searchResult?.items ?? [];
      $[19] = searchResult?.items;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    t9 = t10;
  }
  const suggestionList = t9;
  let t10;
  if ($[21] !== contractQueryAddress || $[22] !== searchResult?.hiddenCount) {
    t10 = () => {
      if (contractQueryAddress) {
        return 0;
      }
      return searchResult?.hiddenCount ?? 0;
    };
    $[21] = contractQueryAddress;
    $[22] = searchResult?.hiddenCount;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  searchResult?.hiddenCount;
  let t11;
  if ($[24] !== t10) {
    t11 = t10();
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const hiddenCount = t11;
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => {
      setHideSpam(_temp);
    };
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const handleToggleSpam = t12;
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => {
      setIsOpen(false);
      setQuery("");
      setActiveIndex(0);
    };
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const resetSearch = t13;
  const debouncedQuery = useDebouncedValue(query, debounceMs);
  const isDebouncing = query !== debouncedQuery;
  const isLoading = isAddressQuery && addressOverviewQuery.isFetching || !isAddressQuery && query.length > 1 && (isSearchFetching || isDebouncing);
  let t14;
  if ($[28] !== activeIndex || $[29] !== hiddenCount || $[30] !== hideSpam || $[31] !== isLoading || $[32] !== isOpen || $[33] !== query || $[34] !== suggestionList) {
    t14 = {
      query,
      setQuery,
      isOpen,
      setIsOpen,
      activeIndex,
      setActiveIndex,
      hideSpam,
      suggestionList,
      hiddenCount,
      handleToggleSpam,
      resetSearch,
      primeContractCache,
      isLoading
    };
    $[28] = activeIndex;
    $[29] = hiddenCount;
    $[30] = hideSpam;
    $[31] = isLoading;
    $[32] = isOpen;
    $[33] = query;
    $[34] = suggestionList;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}
function _temp(prev) {
  return !prev;
}